import { datadogLogs } from '@datadog/browser-logs';

export const initDatadogLogs = () => {
  datadogLogs.init({
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE,
    service: 'dco-studio',
    env: process.env.NEXT_PUBLIC_VERCEL_ENV,
    version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  });
};

export const logError = (error, context = {}) => {
  datadogLogs.logger.error(error.message, {
    error,
    ...context,
  });
};

export const logInfo = (message, context = {}) => {
  datadogLogs.logger.info(message, context);
};

export const logWarning = (message, context = {}) => {
  datadogLogs.logger.warn(message, context);
};
